import { useCallback } from 'react'
import RefreshIcon from '@mui/icons-material/Refresh'
import { FormattedMessage, useIntl } from 'react-intl'
import styles from './PostedFilter.pcss'
import PPSelect, { PPSelectOptions } from 'components/PPSelect'
import { useDispatch } from 'react-redux'
import { message } from 'services/snackbar'
import Button from '@mui/material/Button'
import { PostDestination } from 'shared/types'
import { BRAND_GOOGLE, BRAND_YOUTUBE, BRAND_BLUESKY, BRAND_TIKTOK, BRAND_TWITTER } from 'shared/constants'

interface PostedFilterProps {
  externalPostedVisible: boolean
  selectedProfiles: PostDestination[]
  className?: string
  toggleExternalPostedVisible: () => void
  onRefresh: () => void
}

export function PostedFilter(props: PostedFilterProps) {
  const intl = useIntl()
  const dispatch = useDispatch()
  const { externalPostedVisible, selectedProfiles, toggleExternalPostedVisible } = props
  const allPostsVisible = props.externalPostedVisible
  const isUnsupportedNetwork = [BRAND_TIKTOK, BRAND_YOUTUBE, BRAND_GOOGLE, BRAND_BLUESKY, BRAND_TWITTER]
    .includes(selectedProfiles[0]?.type as any) || selectedProfiles[0]?.isLinkedinPersonalProfile
  const allowExternal = selectedProfiles.length === 1 && !selectedProfiles[0].fbGroup && !isUnsupportedNetwork

  const warnMultipleProfiles = () => {
    if (!allowExternal) {
      let msg = isUnsupportedNetwork
        ? 'post.notifications.external-posted-unsupported'
        : 'post.notifications.external-posted-multi-profiles'

      if (selectedProfiles[0]?.type === BRAND_TWITTER) {
        msg = 'post.notifications.external-posted-twitter'
      }
      dispatch(message(intl.formatMessage({ id: msg }), 'warning', undefined, true))
    }
  }

  const options: PPSelectOptions = {
    pp: { label: 'Post Planner' },
    all: { label: <span onClick={warnMultipleProfiles}>Any Publisher</span>, disabled: !allowExternal }
  }

  const onSelectionChange = useCallback((visible: 'pp' | 'all') => {
    if ((visible === 'pp' && externalPostedVisible) || (visible === 'all' && !externalPostedVisible)) {
      toggleExternalPostedVisible()
    }
  }, [externalPostedVisible, toggleExternalPostedVisible])

  return (
    <div data-test="posted-filter" className={`${styles.container} ${props.className || ''}`}>
      <PPSelect
        name="Posted via"
        options={options}
        withCaret
        selectedValue={allPostsVisible ? 'all' : 'pp'}
        onSelectionChange={onSelectionChange}
      />
      {props.externalPostedVisible && (
        <Button
          startIcon={<RefreshIcon className={styles['icon-refresh']} />}
          className={styles['refresh-button']}
          onClick={props.onRefresh}
        >
          <FormattedMessage id="actions.refresh-posts" />
        </Button>
      )}
    </div>
  )
}

export default PostedFilter
